import "./datepicker.scss";
import { useState, useEffect, useContext } from "react";
import Form from "react-bootstrap/Form";

import { roleRead } from "../../../shared/constants/user-roles";
import AuthContext from "../../../shared/context/auth-context";

export interface IDates {
  from: string;
  until: string;
}

export interface IProps {
  label?: string;
  handleOnChange(newValue: string | IDates, key?: string, id?:string): void;
  mode?: string;
  data?: IDates;
  required?: boolean;
  disabled?: boolean;
  valueType?: string;
}

const Datepicker = ({ label, valueType, required, disabled, data, handleOnChange, mode }: IProps) => {
  const [dateFrom, setDateFrom] = useState<string>("");
  const [dateUntil, setdateUntil] = useState<string>("");
  const [readOnlyState, setReadOnlyState] = useState(false);
  const authCtx = useContext(AuthContext);

  useEffect(() => {
    const rolesArray = authCtx.selectedTenant.roles;
    if (rolesArray.length <= 1 && rolesArray.indexOf(roleRead) !== -1){
      setReadOnlyState(true);
    } else {
      setReadOnlyState(false);
    }
  }, [authCtx.selectedTenant.roles]);

  useEffect(() => {
    if (data) {
      setDateFrom(data.from);
      setdateUntil(data.until);
    }
  }, [data]);

  return (
    <div className="datepicker">
      <span className={mode === "aside" ? "datepicker-aside-label" : ""}>
        <Form.Label>
          {label}
          {required && <span className="datepicker-requiredMark">*</span>}
        </Form.Label>
      </span>
      <Form.Group
        className={mode === "aside" ? "datepicker-aside" : ""}
      >
        <span className="datepicker-subLabel">from</span>
        <Form.Control
          disabled={disabled ? disabled : readOnlyState}
          type={valueType? valueType : "month"}
          name="duedate"
          role="combobox"
          placeholder="Due date"
          value={dateFrom}
          required={required}
          className="datepicker-input"
          onChange={(e) => {
            setDateFrom(e.target.value);
            handleOnChange({ from: e.target.value, until: dateUntil}, "timeframe");
          }}
        />
        <span className="datepicker-subLabel">until</span>
        <Form.Control
          disabled={disabled? disabled : readOnlyState}
          type={valueType? valueType : "month"}
          name="duedate"
          role="combobox"
          required={required}
          placeholder="Due date"
          value={dateUntil}
          className="datepicker-input"
          onChange={(e) => {
            setdateUntil(e.target.value);
            handleOnChange({ from: dateFrom, until: e.target.value}, "timeframe");
          }}
        />
      </Form.Group>
    </div>
  );
};

export default Datepicker;
